import { FC } from 'react';
import { IntlShape } from 'react-intl';

import StrongText, { StrongTextProps } from './StrongText';

interface OwnProps {
    className?: string;
    collectionStyling?: boolean;
    duration?: string | number | undefined;
    intl: IntlShape;
    priceinformation: {
        [key: string]: string | number | unknown;
        pricedays: number;
        priceinformation: string;
        pricelabel: string;
        pricelabeltype: number;
        standardprice: number;
    };
    withEmptyText?: boolean;
    withGross?: boolean;
    withGrossWithoutTage?: boolean;
}

type Props = OwnProps & StrongTextProps;

const Price: FC<Props> = ({
    className,
    priceinformation,
    withGross = false,
    withGrossWithoutTage = false,
    withEmptyText = false,
    duration,
    intl,
    collectionStyling = false,
    ...props
}) => {
    const formatPrice = (_price: string | number) => {
        if (typeof _price !== 'string') {
            const isWholeNumber = Number.isInteger(_price);
            return (isWholeNumber ? _price.toFixed(0) : _price.toFixed(2)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        }
        return _price;
    };

    const getPrice = () => {
        switch (priceinformation.pricelabeltype) {
            case 0:
                // Text with currency and formatting comes from BE
                return priceinformation.pricelabel;
            case 1:
                // Short text instead of price, to be implemented later
                return priceinformation.pricelabel;
            case 2:
                // No use cases so far
                return priceinformation.pricelabel;
            default:
                return intl.formatMessage(
                    { id: 'general.price', defaultMessage: 'CHF {price}' },
                    { price: formatPrice(priceinformation.standardprice) }
                );
        }
    };

    if (priceinformation && intl) {
        return (
            <div className={className}>
                <StrongText {...(collectionStyling ? { color: '#484848' } : {})} {...props}>
                    {getPrice()}
                </StrongText>

                {withGross &&
                    !withGrossWithoutTage &&
                    duration &&
                    intl.formatMessage(
                        { id: 'general.priceGross', defaultMessage: 'Brutto-Preis für {duration}' },
                        { duration }
                    )}

                {withGrossWithoutTage &&
                    !withGross &&
                    duration &&
                    intl.formatMessage(
                        { id: 'general.priceGrossWithoutTage', defaultMessage: 'Brutto-Preis für {duration}' },
                        { duration }
                    )}
            </div>
        );
    }

    if (withEmptyText && !priceinformation && intl) {
        return (
            <StrongText className={className} {...props}>
                {intl.formatMessage({ id: 'general.emptyPrice', defaultMessage: 'Preis auf Anfrage' })}
            </StrongText>
        );
    }

    return null;
};

export default Price;
